// League hierarchy and promotion targets.
// Keep in sync with supabase/functions/compute-pressure-gauge/index.ts

export const LEAGUE_HIERARCHY: Record<string, string> = {
  ENG_CH: "ENG_PL",
  ENG_L1: "ENG_CH",
  ENG_L2: "ENG_L1",
  ESP_L2: "ESP_LL",
  ESP_SL: "ESP_LL",
  GER_B2: "GER_BL",
  ITA_SB: "ITA_SA",
  FRA_L2: "FRA_L1",
  BRA_SB: "BRA_SA",
};

// Top X finish = promotion / promotion playoff
export const PROMOTION_TARGETS: Record<string, number> = {
  ENG_CH: 6,
  ENG_L1: 6,
  ENG_L2: 7,
  ESP_L2: 3,
  ESP_SL: 3,
  GER_B2: 3,
  ITA_SB: 3,
  FRA_L2: 3,
  BRA_SB: 4,
};

export function getHigherLeague(league: string): string | null {
  return LEAGUE_HIERARCHY[league] || null;
}

export function getPromotionTarget(league: string): number {
  return PROMOTION_TARGETS[league] ?? 6;
}
